export class FenceConstants {
  public static readonly FENCE_HEIGHT_95 = 95;
  public static readonly FENCE_HEIGHT_139 = 139;
  public static readonly FENCE_HEIGHT_183 = 183;
  public static readonly FENCE_WIDTH = 183;
  public static readonly MAX_WALL_HEIGHT = 147;
}
